import Game from "./Game";

export default class KeyboardControls {
  constructor(scene, callback) {
    this.scene = scene;
    this.callback = callback;
    this.isPanning = false; // Per la rotazione continua con frecce
    this.isZooming = false; // Per il controllo dello zoom
    this.panTimeout = null; // Timeout per il ritardo iniziale
    this.panInterval = null; // Intervallo per la ripetizione continua
    this.zoomTimeout = null; // Timeout per il ritardo iniziale dello zoom
    this.zoomInterval = null; // Intervallo per lo zoom continuo
    this.initialDelay = 300;
    this.repeatDelay = Game.autoPlayInterval;
    this.initKeyboardControls();
  }

  initKeyboardControls() {
    // Ascolta gli eventi da tastiera
    this.scene.input.keyboard.on("keydown", this.handleKeyDown.bind(this));
    this.scene.input.keyboard.on("keyup", this.handleKeyUp.bind(this));
  }

  handleKeyDown(event) {
    // eslint-disable-next-line default-case
    switch (event.key) {
      case "ArrowRight":
      case "d":
      case "D":
        this.startPan("right");
        break;
      case "ArrowLeft":
      case "a":
      case "A":
        this.startPan("left");
        break;
      case "ArrowUp":
      case "+":
      case "w":
      case "W":
        this.startZoom("in");
        break;
      case "ArrowDown":
      case "-":
      case "s":
      case "S":
        this.startZoom("out");
        break;
    }
  }

  handleKeyUp(event) {
    // eslint-disable-next-line default-case
    switch (event.key) {
      case "ArrowRight":
      case "ArrowLeft":
      case "d":
      case "D":
      case "a":
      case "A":
        this.stopPan();
        break;
      case "ArrowUp":
      case "ArrowDown":
      case "w":
      case "W":
      case "s":
      case "S":
      case "+":
      case "-":
        this.stopZoom();
        break;
    }
  }

  startPan(direction) {
    if (this.isPanning) return;

    this.isPanning = true;

    // Esegue subito il primo movimento
    this.pan(direction);

    // Dopo un ritardo, inizia a ripetere l'azione
    this.panTimeout = setTimeout(() => {
      this.panInterval = setInterval(() => this.pan(direction), this.repeatDelay);
    }, this.initialDelay); // Ritardo prima di iniziare la ripetizione
  }

  stopPan() {
    this.isPanning = false;
    clearTimeout(this.panTimeout); // Ferma il timeout iniziale
    clearInterval(this.panInterval); // Ferma l'intervallo di ripetizione
  }

  pan(direction) {
    if (direction === "right") {
      this.callback.call(null, "panOrRotate", 1); // Pan a destra
    } else {
      this.callback.call(null, "panOrRotate", -1); // Pan a sinistra
    }
  }

  startZoom(type) {
    if (this.isZooming) return;

    this.isZooming = true;

    // Esegui subito il primo zoom
    this.zoom(type);

    // Dopo un ritardo, inizia a ripetere l'azione
    this.zoomTimeout = setTimeout(() => {
      this.zoomInterval = setInterval(() => this.zoom(type), this.repeatDelay);
    }, this.initialDelay); // Ritardo prima di iniziare la ripetizione
  }

  stopZoom() {
    this.isZooming = false;
    clearTimeout(this.zoomTimeout); // Ferma il timeout iniziale
    clearInterval(this.zoomInterval); // Ferma l'intervallo di ripetizione
  }

  zoom(type) {
    if (type === "in") {
      this.callback.call(null, "zoom", 1);
    } else {
      this.callback.call(null, "zoom", -1);
    }
  }
}
